import { render, staticRenderFns } from "./Chosen.vue?vue&type=template&id=042ee405&scoped=true&"
import script from "./Chosen.vue?vue&type=script&lang=js&"
export * from "./Chosen.vue?vue&type=script&lang=js&"
import style0 from "./Chosen.vue?vue&type=style&index=0&id=042ee405&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042ee405",
  null
  
)

export default component.exports